<template lang="pug">
.networkEdit
  .row
    .col-md-4.col-md-offset-4
      h1 {{lang['Edit network']}}
      .form-group
        label {{lang['Name']}}
        input.form-control(type="text" v-model="network.name")
      .form-group
        label {{lang['Description']}}
        input.form-control(type="text" v-model="network.description")
      .form-group
        label {{lang['Lang']}}
        input.form-control(type="text" v-model="network.lang")
      .form-group
        label {{lang['Timezone']}}
        input.form-control(type="text" v-model="network.timezone")
      transition(name="fade" mode="out-in")
        div
          button.btn.btn-primary(@click="save()") {{lang['Save']}}
          button.btn.btn-default(@click="$router.push('/networklist')")
            i.fa.fa-chevron-left
            | &nbsp;&nbsp;{{lang['Return to list']}}
      .small
        sup *
        | {{lang['all fields required']}}
</template>
<script>
export default {
  name: 'networkEdit',
  props: ['lang'],
  data () {
    return {
      network: {}
    }
  },
  methods: {
    save () {
      if (this.$route.params.networkId) {
        this.saveNetwork()
      } else {
        this.addNetwork()
      }
    },
    addNetwork () {
      const network4update = JSON.parse(JSON.stringify(this.network))
      // prepare data
      this.$http.post(`network`, network4update)
        .then(response => {
          console.info(response)
          if (response.ok) {
            this.$notify(`${this.lang['Updated']} `, 'success')
          }
        })
        .catch(data => {
          if (data.body) {
            switch (data.body.code) {
              case 'E_UNIQUE':
                const field = []
                switch (true) {
                  case data.body.attrNames.includes('name'):
                    field.push(this.lang['Name'])
                    break
                  case data.body.attrNames.includes('description'):
                    field.push(this.lang['Description'])
                    break
                  case data.body.attrNames.includes('lang'):
                    field.push(this.lang['Lang'])
                    break
                  case data.body.attrNames.includes('timezone'):
                    field.push(this.lang['Timezone'])
                    break
                }
                this.$notify(`${this.lang['Error, field']} "${field.join(',')}" ${this.lang['with this values exists']} `, 'error', {permanent: true})
                break
              case 'E_INVALID_NEW_RECORD':
                this.$notify(`${this.lang['Invalid values']}<br>${data.body.details}`, 'error', {mode: 'html', permanent: true})
                break
            }
          }
        })
    },
    saveNetwork () {
      const network4update = JSON.parse(JSON.stringify(this.network))
      // prepare data
      delete network4update.id
      delete network4update.createdAt
      delete network4update.updatedAt
      delete network4update.networkerrormatrix
      this.$http.patch(`network/${this.network.id}`, network4update)
        .then(response => {
          console.info(response)
          if (response.ok) {
            this.$notify(`${this.lang['Updated']} `, 'success')
          }
        })
        .catch(data => {
          if (data.body) {
            switch (data.body.code) {
              case 'E_UNIQUE':
                const field = []
                switch (true) {
                  case data.body.attrNames.includes('name'):
                    field.push(this.lang['Name'])
                    break
                  case data.body.attrNames.includes('description'):
                    field.push(this.lang['Description'])
                    break
                  case data.body.attrNames.includes('lang'):
                    field.push(this.lang['Lang'])
                    break
                  case data.body.attrNames.includes('timezone'):
                    field.push(this.lang['Timezone'])
                    break
                }
                this.$notify(`${this.lang['Error, field']} "${field.join(',')}" ${this.lang['with this values exists']} `, 'error', {permanent: true})
                break
              case 'E_INVALID_VALUES_TO_SET':
                this.$notify(`${this.lang['Invalid values']}<br>${data.body.details}`, 'error', {mode: 'html', permanent: true})
                break
            }
          }
        })
    }
  },
  beforeCreate () {
    if (this.$route.params.networkId) {
      this.$http.get(`network/${this.$route.params.networkId}`)
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.network = data
        })
    }
  }
}
</script>
<style lang="sass">
@import "~sass/_variables"
.networkEdit
  .btn
    margin-right: 20px
  .small
    margin-top: 20px
</style>



// WEBPACK FOOTER //
// src/components/network/NetworkEdit.vue